import { getWishlistStorage } from '@jsmdg/browser-storage';
export var getWishlist = function () {
    var wishlistStorage = getWishlistStorage();
    return wishlistStorage.get();
};
//# sourceMappingURL=getWishlist.js.map